import { buildApi, get, post, patch, destroy } from 'redux-bees';
import store from 'store';
import config from 'config';
import { listenToJobResult } from 'sideEffects/pusher';

/* eslint-disable no-multi-spaces, key-spacing */

const endpoints = {
  getAccount:             { method: get,     path: '/account' },
  logout:                 { method: get,     path: '/sessions' },
  createAccount:          { method: post,    path: '/accounts' },
  updateAccount:          { method: patch,   path: '/account' },
  updatePassword:         { method: patch,   path: '/account/update_password' },
  confirmAccount:         { method: patch,   path: '/account/confirm_account' },
  extendTrial:            { method: patch,   path: '/account/extend_trial' },
  skipTour:               { method: patch,   path: '/account/skip_tour' },
  getAccountOtpSecret:    { method: get,     path: '/account/otp_secret' },
  activate2fa:            { method: patch,    path: '/account/activate_2fa' },
  deactivate2fa:          { method: patch,    path: '/account/deactivate_2fa' },

  requestPasswordReset:   { method: post,    path: '/account/reset_password' },
  activateAccount:        { method: patch,    path: '/account/activate_account' },

  getPlans:               { method: get,     path: '/plans' },
  getInvoices:            { method: get,     path: '/invoices' },
  getInvoicePdf:          { method: get,     path: '/invoices/:id/pdf' },

  getBillingProfile:      { method: get,     path: '/billing_profile' },
  updateBillingInfo:      { method: patch,   path: '/billing_profile' },
  updateCardInfo:         { method: patch,   path: '/billing_profile/card' },

  createSession:          { method: post,    path: '/sessions' },
  createWpSession:        { method: post,    path: '/sites/:id/wp_login' },

  importSite:             { method: post,    path: '/sites/import' },
  createSite:             { method: post,    path: '/sites' },
  updateSite:             { method: patch,   path: '/sites/:id' },
  getSite:                { method: get,     path: '/sites/:id' },
  getSites:               { method: get,     path: '/sites' },
  destroySite:            { method: destroy, path: '/sites/:id' },
  resetSite:              { method: post,    path: '/sites/:id/reset' },
  cloneSite:              { method: post,    path: '/sites/:id/clone' },
  reactivateSite:         { method: post,    path: '/sites/:id/reactivate' },
  getSiteImport:          { method: get,     path: '/sites/:siteId/import' },

  getWpUsers:             { method: get,     path: '/sites/:siteId/relationships/wp_users' },
  getSiteWpPlugins:       { method: get,     path: '/sites/:siteId/relationships/site_wp_plugins' },

  createSitePlanChange:   { method: post,    path: '/plan_changes' },

  triggerDeploy:          { method: post,    path: '/sites/:siteId/relationships/deploys' },
  getDeploys:             { method: get,     path: '/sites/:siteId/relationships/deploys' },
  getDeploy:              { method: get,     path: '/sites/:siteId/relationships/deploys/:id' },
  getDeployLog:           { method: get,     path: '/sites/:siteId/relationships/deploys/:id/log' },

  getBackups:             { method: get,     path: '/sites/:siteId/relationships/backups' },
  getBackup:              { method: get,     path: '/sites/:siteId/relationships/backups/:id' },
  restoreBackup:          { method: patch,   path: '/sites/:siteId/relationships/backups/:id/restore' },
  requestBackupDownload:  { method: post,    path: '/sites/:siteId/relationships/backups/:id/download' },
  restoreDeploy:          { method: patch,   path: '/sites/:siteId/relationships/deploys/:id/restore' },
  requestDeployDownload:  { method: post,    path: '/sites/:siteId/relationships/deploys/:id/download' },
  cancelDeploy:           { method: patch,   path: '/sites/:siteId/relationships/deploys/:id/cancel' },

  startSite:              { method: post,    path: '/sites/:id/wordpress/start' },
  stopSite:               { method: post,    path: '/sites/:id/wordpress/stop' },
  startPma:               { method: post,    path: '/sites/:id/pma/start' },
  stopPma:                { method: post,    path: '/sites/:id/pma/stop' },

  setCustomDomain:        { method: post,    path: '/sites/:id/set_custom_domain' },
  setCustomFc7Sender:     { method: post,    path: '/sites/:id/set_custom_cf7_sender' },
  setCacheExpiration:     { method: post,    path: '/sites/:id/set_cache_expiration' },
  setMaxAges:             { method: post,    path: '/sites/:id/set_max_ages' },
  enableSsl:              { method: post,    path: '/sites/:id/ssl/enable' },
  disableSsl:             { method: post,    path: '/sites/:id/ssl/disable' },

  triggerMigration:       { method: post,    path: '/sites/:id/migrate' },

  getLogs:                { method: get,     path: '/logs' },
};

/* eslint-enable no-multi-spaces, key-spacing */

const options = {
  baseUrl: config.apiBaseUrl,
  configureHeaders(headers) {
    const token = store.getState().session.accessToken;

    if (token) {
      return {
        ...headers,
        Authorization: `Bearer ${token}`,
      };
    }

    return headers;
  },
  afterReject(result) {
    if (result.status === 503) {
      document.location = '/maintenance';
      return null;
    } else if (result.status === 504) {
      alert('Server busy. Try later!');
    } else if (result.status === 401) {
      store.dispatch({ type: 'LOGOUT' });
      return undefined;
    }

    return Promise.reject(result);
  },
  afterResolve(result) {
    if (result && result.body.data && result.body.data.type === 'job') {
      return new Promise((resolve, reject) => {
        listenToJobResult(result.body.data.id, (status, payload) => {
          if (status >= 200 && status < 300) {
            resolve({ status, body: payload, headers: {} });
          } else {
            reject({ status, body: payload, headers: {} });
          }
        });
      });
    }

    return Promise.resolve(result);
  },
};

export default buildApi(endpoints, options);



// WEBPACK FOOTER //
// ./app/api.js